import React, { useState } from 'react';
import { toast } from '../../toasts';
import { useLocation, useNavigate } from 'react-router-dom';
import ContactService from '../../services/contact.service';
import { getError } from '../../utils';
import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal';
import { Section, DataTable, RowActionsMenu, Button } from '../../components/EntityList';
import { useLabels } from '../../hooks/useLabels';

function AccountContacts({ accountId, rows, loading, error, onRefetch }) {
	const { t } = useLabels();
	const navigate = useNavigate();
	const location = useLocation();
	const [deletingContact, setDeletingContact] = useState(null);

	const returnTo = () => encodeURIComponent(location.pathname + location.search);

	const handleCreateContact = () => {
		navigate(`/AdminScreen/accounts/account/${accountId}/newContact?returnTo=${returnTo()}`);
	};

	const handleEditContact = (contact) => {
		navigate(`/AdminScreen/contacts/editContact/${contact._id}?returnTo=${returnTo()}`);
	};

	async function handleConfirmDelete() {
		try {
			await ContactService.delete(deletingContact._id);
			toast.success('Contacto Eliminado');
			onRefetch();
		} catch (err) {
			toast.error(getError(err));
		} finally {
			setDeletingContact(null);
		}
	}

	const columns = [
		{ key: 'name', header: 'Nombre', render: (contact) => contact.name },
		{ key: 'email', header: 'Email', render: (contact) => contact.email },
		{ key: 'address', header: 'Dirección', render: (contact) => contact.address },
		{ key: 'phone', header: 'Teléfono', render: (contact) => contact.phone },
		{ key: 'folder', header: 'Carpeta', render: (contact) => contact.folder },
	];

	const renderRowActions = (contact) => (
		<RowActionsMenu
			items={[
				{ label: 'Editar', onClick: () => handleEditContact(contact) },
				{ label: 'Eliminar', onClick: () => setDeletingContact(contact), danger: true },
			]}
		/>
	);

	return (
		<div className='tw:flex tw:flex-col tw:gap-4'>
			<div className='tw:flex tw:justify-end'>
				<Button size='sm' variant='primary' onClick={handleCreateContact}>
					Nuevo contacto
				</Button>
			</div>
			<Section title='Contactos'>
				<DataTable
					columns={columns}
					rows={rows}
					loading={loading}
					error={error}
					rowActions={renderRowActions}
					emptyMessage='No se encontraron contactos para esta cuenta.'
				/>
			</Section>

			<ConfirmationModal
				show={Boolean(deletingContact)}
				handleClose={() => setDeletingContact(null)}
				handleConfirm={handleConfirmDelete}
				title={t('title.deleteContact')}
				description={t('msg.confirmDeleteContact')}
				confirmCaption={t('action.delete')}
				cancelCaption={t('action.cancel')}
			/>
		</div>
	);
}

export default AccountContacts;
